import { Component, Input, OnInit } from '@angular/core';
import { ResidentialStatusService } from '../residential-status.service';
import { ResidentialStatus } from '../residential-status';
import { NotificationService } from '../../shared/notification.service';
import { SelectComparisons } from '../../shared/pipes/select.comparisons';

@Component({
  selector: 'app-residential-status-select',
  templateUrl: 'select.component.html',
})
export class ResidentialStatusSelectComponent extends SelectComparisons
  implements OnInit {
  /**
   * The model that we will be adding the residentialStatus to.
   */
  @Input() model: any;

  /**
   * Do we require this field in the main form it is
   * included in?
   */
  @Input() required: boolean;

  /**
   * A list of all the residential-statuses currently loaded.
   *
   * @type {ResidentialStatus[]}
   */
  public residentialStatuses: ResidentialStatus[] = [];

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = true;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {ResidentialStatusService} residentialStatusService
   * @param {NotificationService} notificationService
   */
  constructor(
    private residentialStatusService: ResidentialStatusService,
    private notificationService: NotificationService,
  ) {
    super();
    this.residentialStatusService.loading.subscribe(isLoading => {
      this.isLoading = isLoading;
    });
  }

  /**
   * When the component is initialised we set it to load
   * page one of the residentialStatus list.
   */
  public ngOnInit(): void {
    this.loadResidentialStatuses(1, 10000);
  }

  /**
   * Loads a list of residential-statuses using the given per page limit.
   *
   * @param {number} page The current page we require.
   * @param {number} limit The number of results per page.
   */
  public loadResidentialStatuses(page?: number, limit?: number): void {
    const listResidentialStatuses = this.residentialStatusService
      .listResidentialStatuses(page, limit)
      .subscribe((residentialStatuses: ResidentialStatus[]) => {
        this.residentialStatuses = residentialStatuses;
        listResidentialStatuses.unsubscribe();
      });
  }
}
